import { defineMessages } from 'react-intl';
import { object, string, boolean } from 'yup';

const messages = defineMessages({
  invalidZipCode: {
    id: 'address.invalidZipCode',
    defaultMessage: 'Invalid zip code.',
  },
  invalidPhone: {
    id: 'address.invalidPhone',
    defaultMessage: 'Please enter a valid US phone number.',
  },
  over35Chars: {
    id: 'address.over35Chars',
    defaultMessage: '35 characters maximum.',
  },
  over20Chars: {
    id: 'address.over20Chars',
    defaultMessage: '20 characters maximum.',
  },
});

export default object({
  attention: string()
    .nullable()
    .max(35, messages.over35Chars),
  name: string()
    .required()
    .max(35, messages.over35Chars),
  line1: string()
    .required()
    .max(35, messages.over35Chars),
  line2: string()
    .default('')
    .max(35, messages.over35Chars),
  city: string()
    .required()
    .max(20, messages.over20Chars),
  state: string().required(),
  postalCode: string()
    .required()
    .matches(/\d{5}/, messages.invalidZipCode),
  phone: string()
    .required()
    .test(
      'phone',
      messages.invalidPhone,
      value => value == null || value.replace(/[^\d]/g, '').length === 10,
    ),
  country: string()
    .default('US')
    .required(),
  eventPickup: boolean()
    .default(false)
    .required(),
});
